<!-- 富文本 -->
<template>
  <div class="editor-container">
    <editor id="tinymce-editor" v-model="contentData" :init="init" ref="editorRef"></editor>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/plugins/image'; // 插入上传图片插件
import 'tinymce/plugins/link'; // 插入超链接插件
import 'tinymce/plugins/fullscreen'; // 引入全屏插件
import 'tinymce/icons/default/icons.min.js';
export default {
  props: ['content'],
  components: {
    Editor,
  },
  watch: {
    content: {
      immediate: true,
      handler: function(newValue) {
        this.contentData = newValue;
      }
    }
  },
  data() {
    return {
      contentData: '',
      init: {
        selector: '#tinymce-editor',
        menubar: false,
        language_url: `${this.$utils.siteBase()}tinymce/zh_CN.js`,
        relative_urls: false,
        remove_script_host: false,
        language: 'zh_CN',
        skin_url: `${this.$utils.siteBase()}tinymce/skins/ui/oxide`,
        min_height: 300,
        height: '100%',
        plugins: 'image link fullscreen',
        toolbar: 'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image | removeformat | fullscreen',

        // tinymce插入图片支持转base64操作
        images_upload_handler: (blobInfo, success, failure) => {
          const uploadedImages = {
            name: blobInfo.filename(),
            url: URL.createObjectURL(blobInfo.blob()),
            size: blobInfo.blob().size,
            raw: blobInfo.blob(),
          };
          this.uploadImg(uploadedImages).then((res) => {
            success(res.fileUrl);
          });
        },
        branding: false,
      },
    };
  },
  mounted() {
    tinymce.init({});
  },
  methods: {
    // 将选择的图片上传
    async uploadImg(file) {
      const item = {
        raw: file.raw,
        filename: file.name,
        size: file.size,
      };
      const res = await this.$upload.start(item);
      return new Promise((resolve) => {
        if (res) {
          resolve(res);
        }
      });
    },
    // 设置只读
    readonlyFun() {
      setTimeout(function () {
        if (tinymce.editors['tinymce-editor']) {
          tinymce.editors['tinymce-editor'].setMode('readonly');
        }
      }, 1000);
    },
    // 设置可以写
    designFun() {
      setTimeout(function () {
        if (tinymce.editors['tinymce-editor']) {
          tinymce.editors['tinymce-editor'].setMode('design');
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
  .editor-container{
    height: 100%;
    width: 100%;
  }
</style>
<style>
.tox-tinymce-aux {
  z-index: 9999 !important;
}
</style>
